/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Transfer_Export_TitleInputs */

const en_us2_history_transfer_export_title = /** @type {(inputs: History_Transfer_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export workouts`)
};

const pt_br2_history_transfer_export_title = /** @type {(inputs: History_Transfer_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar treinos`)
};

const es_419_history_transfer_export_title = /** @type {(inputs: History_Transfer_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar entrenamientos`)
};

const pt_pt2_history_transfer_export_title = /** @type {(inputs: History_Transfer_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar treinos`)
};

const fr_fr2_history_transfer_export_title = /** @type {(inputs: History_Transfer_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter les séances`)
};

const de_de2_history_transfer_export_title = /** @type {(inputs: History_Transfer_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainings exportieren`)
};

const it_it2_history_transfer_export_title = /** @type {(inputs: History_Transfer_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporta allenamenti`)
};

/**
* | output |
* | --- |
* | "Export workouts" |
*
* @param {History_Transfer_Export_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const history_transfer_export_title = /** @type {((inputs?: History_Transfer_Export_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Transfer_Export_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_history_transfer_export_title(inputs)
	if (locale === "es-419") return es_419_history_transfer_export_title(inputs)
	if (locale === "pt-PT") return pt_pt2_history_transfer_export_title(inputs)
	if (locale === "fr-FR") return fr_fr2_history_transfer_export_title(inputs)
	if (locale === "de-DE") return de_de2_history_transfer_export_title(inputs)
	if (locale === "it-IT") return it_it2_history_transfer_export_title(inputs)
	return en_us2_history_transfer_export_title(inputs)
});
export { history_transfer_export_title as "history-transfer.export_title" }